<template>
  <v-dialog persistent v-model="withdrawalDetailsDialog" width="700">
    <v-card>
      <v-card-title class="headline grey lighten-2"
        >Withdrawal Details</v-card-title
      >

      <v-card-text class="pt-3 p-0">
        <div>
          <CCol sm="12" class="p-0">
            <CCol sm="12" class="pt-0">
              <CRow>
                <CCol sm="2" class="pl-5">
                  <p class="mb-0">Name :</p>
                </CCol>
                <CCol sm="10">
                  <p class="mb-0">
                    <b>{{ details.name || "-" }}</b>
                  </p>
                </CCol>
              </CRow>
            </CCol>
            <CCol sm="12" class="pt-0">
              <CRow>
                <CCol sm="2" class="pl-5">
                  <p class="mb-0">Amount :</p>
                </CCol>
                <CCol sm="10">
                  <p class="mb-0">
                    <b>&#8377; {{ details.points }}</b>
                  </p>
                </CCol>
              </CRow>
            </CCol>
            <!-- <CCol sm="12" class="py-0 pl-5">
              <small>Amount in words : (One thousand)</small>
            </CCol> -->
            <!-- ................. -->
            <hr />
            <!-- ................. -->
            <CCol sm="12" class="py-0 pl-5">
              <p>
                <b>Bank Details</b>
              </p>
            </CCol>
            <CCol sm="12" class="pt-0">
              <!-- <CRow>
                <CCol sm="3" class="pl-5">
                  <p class="mb-0">Bank Name :</p>
                </CCol>
                <CCol sm="9">
                  <p class="mb-0">{{ details.bank_name || 'NA' }}</p>
                </CCol>
              </CRow> -->
            </CCol>
            <CCol sm="12" class="pt-0">
              <CRow>
                <CCol sm="3" class="pl-5">
                  <p class="mb-0">Account Number :</p>
                </CCol>
                <CCol sm="9">
                  <p class="mb-0">{{ details.account_number }}</p>
                </CCol>
              </CRow>
            </CCol>
            <CCol sm="12" class="pt-0">
              <CRow>
                <CCol sm="3" class="pl-5">
                  <p class="mb-0">IFSC Code :</p>
                </CCol>
                <CCol sm="9">
                  <p class="mb-0">{{ details.ifsc_code }}</p>
                </CCol>
              </CRow>
            </CCol>
            <CCol sm="12" class="pt-0">
              <CRow>
                <CCol sm="3" class="pl-5">
                  <p class="mb-0">A/C Type :</p>
                </CCol>
                <CCol sm="9">
                  <p class="mb-0">{{ details.account_type }}</p>
                </CCol>
              </CRow>
            </CCol>
            <!-- ................. -->
            <CCol sm="12" class="bg-light text-dark">
              <CRow>
                <CCol sm="7" class="pl-5">
                  <p class="mb-0">
                    <b>Approved by :</b>
                  </p>
                  <p class="mb-0">
                    {{ $store.state.user.userDetails.first_name || "NA" }}
                  </p>
                </CCol>
                <CCol sm="5" class="pr-5">
                  <label for>UTR Number</label>

                  <input
                    v-if="details.status !== 'processed'"
                    type="text"
                    v-model="utr_number"
                    class="form-control"
                    placeholder="123456"
                  />
                  <p v-else>
                    {{ details.utr_number }}
                  </p>
                </CCol>
              </CRow>
            </CCol>
          </CCol>
        </div>
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="close" color="error" >Cancel</v-btn>
        <v-btn
          v-if="details.status !== 'processed'"
          @click="save"
          color="green"
          dark
          >Approve</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ["withdrawalDetailsDialog", "details"],
  data() {
    return {
      utr_number: "",
    };
  },
  methods: {
    save() {
      this.$emit("save", this.utr_number);
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>